(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-pdp-craft-details"] && !Shopify.designMode) return;
  try {
    
(function() {
  const tabBtns = document.querySelectorAll('.accio-pdp-tab-btn');
  const tabPanels = document.querySelectorAll('.accio-pdp-tab-panel');

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const idx = btn.dataset.tabIndex;

      tabBtns.forEach(function(b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });

      tabPanels.forEach(function(p) {
        p.classList.remove('is-active');
        p.setAttribute('hidden', '');
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      const panel = document.getElementById('accio-pdp-tab-panel-' + idx);
      if (panel) {
        panel.classList.add('is-active');
        panel.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axisia-colour-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function findByKey(list, key) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].dataset.axcsKey === key) return list[i];
    }
    return null;
  }

  function init(root) {
    if (!root || root.getAttribute('data-axcs-ready') === 'true') return;
    root.setAttribute('data-axcs-ready', 'true');

    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-axcs-swatch]'));
    if (!swatches.length) return;

    var familyButtons = Array.prototype.slice.call(root.querySelectorAll('[data-axcs-fam-btn]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-axcs-row]'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('[data-axcs-pane]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-axcs-detail]'));
    var status = root.querySelector('[data-axcs-status]');
    var motionQuery = window.matchMedia ? window.matchMedia(REDUCED_MOTION_QUERY) : null;

    function prefersReducedMotion() {
      return !!(motionQuery && motionQuery.matches);
    }

    function setActivePanels(list, key) {
      list.forEach(function (el) {
        var isActive = el.dataset.axcsKey === key;
        el.classList.toggle('is-active', isActive);
        if (isActive) {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('inert', '');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function pulse(el) {
      el.classList.remove('is-pulsing');
      void el.offsetWidth;
      el.classList.add('is-pulsing');
      el.addEventListener('animationend', function handler(event) {
        if (event.animationName !== 'axcs-pulse') return;
        el.classList.remove('is-pulsing');
        el.removeEventListener('animationend', handler);
      });
    }

    function ripple(el) {
      var previous = el.querySelector('.axcs__ripple');
      if (previous && previous.parentNode) previous.parentNode.removeChild(previous);
      var ring = document.createElement('span');
      ring.className = 'axcs__ripple';
      ring.setAttribute('aria-hidden', 'true');
      ring.addEventListener('animationend', function () {
        if (ring.parentNode) ring.parentNode.removeChild(ring);
      });
      el.appendChild(ring);
    }

    function announce(key) {
      if (!status) return;
      var pane = findByKey(panes, key);
      status.textContent = pane && pane.dataset.axcsAnnounce ? pane.dataset.axcsAnnounce : '';
    }

    function activate(key, animate) {
      var swatch = findByKey(swatches, key);
      if (!swatch) return;
      if (!animate && root.getAttribute('data-axcs-current') === key) return;

      var family = swatch.dataset.axcsFamily;

      familyButtons.forEach(function (button) {
        var isActive = button.dataset.axcsFamBtn === family;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      rows.forEach(function (row) {
        row.classList.toggle('is-active', row.dataset.axcsRow === family);
      });

      swatches.forEach(function (item) {
        var isSelected = item.dataset.axcsKey === key;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      setActivePanels(panes, key);
      setActivePanels(details, key);
      root.setAttribute('data-axcs-current', key);

      if (animate) {
        announce(key);
        if (!prefersReducedMotion()) {
          pulse(swatch);
          ripple(swatch);
        }
      }
    }

    swatches.forEach(function (swatch, index) {
      swatch.addEventListener('click', function () {
        activate(swatch.dataset.axcsKey, true);
      });

      swatch.addEventListener('keydown', function (event) {
        var target = -1;
        if (event.key === 'ArrowRight') {
          target = (index + 1) % swatches.length;
        } else if (event.key === 'ArrowLeft') {
          target = (index - 1 + swatches.length) % swatches.length;
        } else if (event.key === 'Home') {
          target = 0;
        } else if (event.key === 'End') {
          target = swatches.length - 1;
        }
        if (target < 0 || target === index) return;
        event.preventDefault();
        var next = swatches[target];
        activate(next.dataset.axcsKey, true);
        next.focus();
      });
    });

    familyButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        var family = button.dataset.axcsFamBtn;
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].dataset.axcsFamily === family) {
            activate(swatches[i].dataset.axcsKey, true);
            return;
          }
        }
      });

      button.addEventListener('keydown', function (event) {
        var target = -1;
        if (event.key === 'ArrowRight') {
          target = (index + 1) % familyButtons.length;
        } else if (event.key === 'ArrowLeft') {
          target = (index - 1 + familyButtons.length) % familyButtons.length;
        } else if (event.key === 'Home') {
          target = 0;
        } else if (event.key === 'End') {
          target = familyButtons.length - 1;
        }
        if (target < 0 || target === index) return;
        event.preventDefault();
        familyButtons[target].focus();
        familyButtons[target].click();
      });
    });

    var activePane = root.querySelector('[data-axcs-pane].is-active');
    var initialKey = activePane ? activePane.dataset.axcsKey : swatches[0].dataset.axcsKey;
    activate(initialKey, false);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-axcs]'), init);
    if (scope && scope.matches && scope.matches('[data-axcs]')) init(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
